export default __webpack_public_path__ + "PosAppStoreDownload.png";